<template>
    <div>
        <b-navbar type="light" class="mobile-navbar-frame">
            <!--Back to feedback or measure-->
            <b-navbar-nav class="nav-prev-but">
                <b-nav-item
                    @click="$_onCancel()"
                    :title="$t('feedbackClose')">
                    <div class="icon-label-container">
                        <div
                            class="ml-1 mr-1 chevron-left-icon img-size-24"
                        ></div>
                        <span class="font-weight-bold align-middle">{{
                            $t('labelCloseFeedbackCreate')
                        }}</span>
                    </div>
                </b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="center-horizontal nav-feedback">
                <b-nav-item active>
                    <div class="measure-container">
                        <div
                            class="flexbox1 icon-container"
                            v-bind:class="{
                                invisible: !showButtonUndo || isPoint
                            }"
                            @click="$_onUndo"
                            :title="$t('btnBackLabel')"
                        >
                            <div class="measure-button undo-icon"></div>
                        </div>
                        <div
                            class="flexbox2 button-extra-border measure-totals"
                        >
                            <span>
                                <span class="measure-title"
                                    >{{
                                        $t('pointSelectedPlural')
                                    }}:&nbsp;</span
                                >
                                <span class="measure-value">{{ nPoints }}</span>
                            </span>
                            <div
                                class="close-icon-container icon-container"
                                @click="$_onCancel"
                                :title="$t('labelClearFeedback')"
                            >
                                <div class="measure-button close-icon"></div>
                            </div>
                        </div>
                        <div class="flexbox3">
                            <div
                                class="
                                    icon-container
                                    save-icon-container
                                    d-none
                                "
                                @click="$_onSaveClick"
                                :title="$t('measureSave')"
                            >
                                <div
                                    class="measure-button checkmark-icon"
                                ></div>
                            </div>
                            <b-button
                                id="btn-create-feedback"
                                class="
                                    measure-button-next
                                    d-none d-md-inline-block
                                "
                                variant="primary"
                                @click="$_onSaveClick"
                                :disabled="!canSave"
                            >
                                <div
                                    class="
                                        mr-1
                                        measure-button measure-button-check
                                        checkmark-white-icon
                                    "
                                ></div>
                                {{ getButtonTextCreate }}
                            </b-button>
                        </div>
                    </div>
                </b-nav-item>
            </b-navbar-nav>
            <!--Buttons on the right-->
            <b-navbar-nav class="ml-auto d-none d-md-inline-block">
                <!--Ellipses button for menu-->
                <b-nav-item
                    v-if="
                        $store.getters.isMobile &&
                        menuComponents.mapControls.components.maps.visible
                    "
                    @click="togglePanel({ panelName: userMapsPanelName })"
                    :title="
                        $t(menuComponents.mapControls.components.maps.label)
                    "
                >
                    <div tabindex="1" class="icon-container">
                        <div class="layer-icon img-size-24"></div>
                    </div>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import {
        CONTENT_TYPE_ID,
        INTERFACE_PANEL_TRIGGERS,
        DRAW_MODUS,
        INTERACTION_TYPE
    } from '../../../constants';
    export default {
        name: 'FeedbackPointsControl',

        props: {
            feedbackId: { type: Number, required: true },
            drawObject: { type: Object, required: false }
        },
        data() {
            return {
                showButtonUndo: false,
                contentTypeConst: CONTENT_TYPE_ID,
                userMapsPanelName: INTERFACE_PANEL_TRIGGERS.USERMAPS
            };
        },

        computed: {
            ...mapState(['setFeedbackMenu', 'uiElements']),
            menuComponents: function () {
                return this.uiElements.menuBar.components;
            },
            getButtonTextCreate() {
                return this.$t('labelNext');
            },
            nPoints() {
                if (this.isPolygon) {
                    return (
                        (this.drawObject?.points || 1) -
                        (this.mode === DRAW_MODUS.Draw ? 1 : 0)
                    );
                }
                return this.drawObject?.points || 0;
            },
            geometryType() {
                return this.drawObject?.geometryType;
            },
            isPoint() {
                return this.geometryType === INTERACTION_TYPE.Point;
            },
            isPolygon() {
                return this.geometryType === INTERACTION_TYPE.Polygon;
            },
            mode() {
                return this.drawObject?.mode;
            },
            canSave() {
                if (this.isPoint) {
                    return this.nPoints === 1;
                }
                if (this.isPolygon) {
                    return this.nPoints > 2;
                }
                return this.nPoints > 1;
            },
            isWebFeedback() {
                return this.$store.getters.getWebThemeHasFeedbackType;
            }
        },

        methods: {
            ...mapActions(['togglePanel']),
            /**
             * Reset all values
             */
            $_resetValues() {
                this.nPoints = 0;
                this.showButtonUndo = false;
            },
            $_updatePoints(nPoints) {
                this.nPoints = nPoints;

                if (this.nPoints > 0) {
                    this.showButtonUndo = true;
                } else {
                    this.showButtonUndo = false;
                }
            },
            $_onCancel() {
                this.$emit('cancel');
            },
            $_onSaveClick() {
                this.$emit('save');
            },
            $_onUndo() {
                this.$emit('undo');
            }
        },

        watch: {
            setFeedbackMenu(newValue) {
                if (newValue) {
                    this.$_resetValues();
                }
            }
        }
    };
</script>

<style scoped lang="scss">
.mobile-navbar-frame {
    @include z-index(menu-bar-overlay);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    background: #ffffff;
    box-shadow: 1px 2px 4px rgba(204, 204, 204, 0.5), 0px 2px 0px #a6aebe;
    height: 60px;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
}

.img-size-24 {
    width: 24px;
    height: 24px;
    background-size: 24px;
    -webkit-mask-size: 24px;
    mask-size: 24px;
}

.navbar-nav .nav-link {
    padding-right: 0px;
    padding-left: 0.3rem;
}

.img-size-20x4 {
    width: 20px;
    height: 4px;
    background-size: 20px;
    -webkit-mask-size: 20px;
    mask-size: 20px;
}

/*-------------------------------------
    max-width : 767px
---------------------------------------*/
@media (max-width: $tablet-width) {
    .nav-prev-but {
        margin-top: -25px;
        margin-left: -17px;
        z-index: 1;
    }
    .navbar-light .navbar-nav.center-horizontal.nav-feedback {
        width: calc(100vw - 20px) !important;
    }
}
</style>
